export default __webpack_public_path__ + "static/media/tour-4.5f7cb7b0.svg";